export const PostTypeReel = 'reels'
export const PostTypeFacebookReel = 'facebook_reel'
export const PostTypeFacebookStory = 'facebook_story'
export const PostTypePost = 'post'
export const PostTypeStory = 'story'
export const PostTypeShort = 'short'
export const PostTypeVideo = 'video'
export const PostTypeCarousel = 'carousel'
